import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TopBarComponent} from '../top-bar/top-bar-component';

@Component({
  selector: 'app-blocked-top-bar',
  templateUrl: './blocked-top-bar.component.html',
  styleUrls: ['./blocked-top-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockedTopBarComponent implements TopBarComponent, OnInit {
  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

}
